import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'services/alert.service';
import { FriendDetailsService } from 'services/frienddetails.service';
import {MatDialogModule} from '@angular/material/dialog';

@Component({
  selector: 'app-managecreditpopup',
  templateUrl: './managecreditpopup.component.html',
  styleUrls: ['./managecreditpopup.component.scss']
})
export class ManagecreditpopupComponent implements OnInit {
  form: FormGroup;
  data: any;
  id: Number;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,    
    public dialogRef: MatDialogRef<ManagecreditpopupComponent>,
    private formBuilder: FormBuilder,    
    route: ActivatedRoute,
    private friendDetailsService: FriendDetailsService,   
    private alertService: AlertService) {
      
if (data) {
  this.id =  parseInt(data.id);     
}
     }
  ngOnInit() {
    this.initializeValidators();   
    this.get(this.id);
  }
  
  
  initializeValidators() {
    this.form = this.formBuilder.group({      
      customerName: [], 
      customerNumber: [],
      mobileNumber: [],
      email: [] ,
      accountHolderName: [] , 
      accountNumber: [] ,  
      bank: [] ,  
      branchCode: [] ,
      accountType: [] ,
      id:[],
    });
  }
  
  get(id) {
    if (id > 0) {
      this.friendDetailsService.getBenificiaryInformation(id, true).subscribe(result => {
        this.data = result;
        if (this.data) {
          this.form.patchValue(this.data);
        }
      });
    }
  }


  onCancel() {
    this.dialogRef.close();
  }

  onPay() {    
    this.friendDetailsService.payNow(this.form.value).subscribe(result => {
      if (result) {
        this.dialogRef.close(result);      
     }
    });



  }



}
